import { unref } from 'vue';
import { UPC_VALIDATION_MESSAGES } from '../consts';

/**
 * @typedef VaidateUPCParams
 * @property {Color | null} selectedColor
 * @property {Size | null} selectedSize
 * @property {Orientation | undefined} selectedOrientation
 * @property {Color[]} [colors]
 * @property {Size[]} [sizes]
 * @property {Orientation[]} [orientations]
 * @property {(color: Color, selectedSizeId: number, typeId: number?) => boolean} isColorAvailable
 * @property {(size: Size, selectedColorId: number?, typeId: number?) => boolean} isSizeAvailable
 * @property {boolean} [isConsolidatedMaster]
 * @property {string} [typeName]
 * @property {string} [sizeName]
 * @property {boolean} [excludeColorLabel]
 */
/**
 * * Validate the selected color and size
 * @param {VaidateUPCParams} params
 * @returns {null | string}
 *
 * TODO - add product type validation?
 * TODO - some of products have no size or not type
 * ? - colors, sizes and types are traits of a product with similar structure
 * ? - it seems like there should be a common way to validate them
 */
// eslint-disable-next-line complexity
export const validateUPC = ({
  selectedColor,
  selectedSize,
  selectedOrientation,
  colors,
  sizes,
  orientations,
  isColorAvailable,
  isSizeAvailable,
  isConsolidatedMaster = false,
  typeName,
  sizeName,
  excludeColorLabel,
}) => {
  const colorsExist = colors && colors.length;
  const sizesExist = sizes && sizes.length;
  const orientationsExist = orientations && orientations.length;

  const typeLabel = (typeName || 'orientation').toLowerCase();
  const sizeLabel = (sizeName || 'size').toLowerCase();

  if (colorsExist && !selectedColor) {
    return UPC_VALIDATION_MESSAGES.COLOR_NOT_SELECTED;
  }
  if (orientationsExist && !selectedOrientation) {
    if (sizesExist && !selectedSize) {
      return `${UPC_VALIDATION_MESSAGES.TRAIT_NOT_SELECTED } ${sizeLabel} and ${typeLabel}`;
    }
    if (!typeName) {
      return UPC_VALIDATION_MESSAGES.TYPE_NOT_SELECTED;
    }
    return `${UPC_VALIDATION_MESSAGES.TRAIT_NOT_SELECTED } ${typeName.toLowerCase()}`;
  }
  if (sizesExist && !selectedSize && isConsolidatedMaster) {
    return UPC_VALIDATION_MESSAGES.VALUE_NOT_SELECTED;
  }
  if (sizesExist && !selectedSize) {
    if (!sizeName) {
      return UPC_VALIDATION_MESSAGES.SIZE_NOT_SELECTED;
    }
    return `${UPC_VALIDATION_MESSAGES.TRAIT_NOT_SELECTED } ${sizeName.toLowerCase()}`;
  }

  if (
    (colorsExist && !unref(isColorAvailable)(selectedColor, selectedSize?.id, selectedOrientation?.id))
    || (sizesExist && !unref(isSizeAvailable)(selectedSize, selectedColor?.id, selectedOrientation?.id))
  ) {
    if (isConsolidatedMaster) {
      return UPC_VALIDATION_MESSAGES.VALUE_COLOR_NOT_AVAILABLE;
    }
    if (selectedSize && selectedOrientation) {
      const label = `${sizeLabel}/${typeLabel} ${UPC_VALIDATION_MESSAGES.COMBINATION_NOT_AVAILABLE}`;
      if (excludeColorLabel) {
        return `This ${label}`;
      }
      return `This color/${label}`;
    }
    return UPC_VALIDATION_MESSAGES.SIZE_COLOR_NOT_AVAILABLE;
  }
  return null;
};

export default {
  validateUPC,
};
